document.addEventListener("DOMContentLoaded", function () {
  function initializeCollapsibles() {
    const menuButtons = document.querySelectorAll(
      ".footer-block__collapsible-button"
    );

    menuButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const index = button.dataset.collapsibleIndex;
        const matchedContent = document.querySelector(
          `.footer-block__collapsible-content[data-collapsible-index="${index}"]`
        );

        if (matchedContent) {
          matchedContent.classList.toggle("active");
          const icons = button.querySelectorAll(
            ".footer-block__collapsible-icon"
          );
          icons.forEach((icon) => icon.classList.toggle("active"));
        }
      });
    });
  }

  // Initial initialization when the page loads
  initializeCollapsibles();

  // Listen for changes in the theme editor
  document.addEventListener("shopify:section:load", () => {
    initializeCollapsibles();
  });
});
